import useHasAccessToGoogleRCS from '@rsos/hooks/useHasAccessToGoogleRCS';
import TT911PendingChatCard from '../../CallChats/TT911PendingChatCard';
import { ChatComponentType, useChatComponents } from '../../useChatComponents';
import ConversationsChatCard from './ConversationsChatCard';
import RcsChatCard from './RcsChatCard';
import TF911ChatCard from './TF911ChatCard';

interface ChatCardDisplayProps {
  hasConversation: boolean;
  hasAccessToTF911: boolean;
  shouldRenderRcsChatCard: boolean;
}

/**
 * Handles all conditionals that would determine which chat card to display
 */
const ChatCardDisplay = ({
  hasConversation,
  hasAccessToTF911,
  shouldRenderRcsChatCard,
}: ChatCardDisplayProps) => {
  const { primaryChatKey, isTT911SessionPending } = useChatComponents();
  const hasRCSAccess = useHasAccessToGoogleRCS();

  const getOtherChatCard = () => {
    if (primaryChatKey === ChatComponentType.conversations && hasConversation) {
      return <ConversationsChatCard />;
    }

    if (
      primaryChatKey === ChatComponentType.rcs &&
      hasRCSAccess &&
      shouldRenderRcsChatCard
    ) {
      return <RcsChatCard />;
    }

    // While pending, only show TF911 if there's already a real conversation --
    // otherwise it's an unrelated Start Chat next to the "please wait" notice.
    if (
      hasAccessToTF911 &&
      (!isTT911SessionPending || primaryChatKey === ChatComponentType.tf911)
    ) {
      return <TF911ChatCard />;
    }

    return null;
  };

  const otherChatCard = getOtherChatCard();

  if (isTT911SessionPending) {
    return (
      <>
        <TT911PendingChatCard />
        {otherChatCard}
      </>
    );
  }

  return otherChatCard;
};

export default ChatCardDisplay;
